export default __webpack_public_path__ + "static/media/users_ic.5d340762.svg";